module.exports = {
	title: "separator",
	icon: "<i class='vw-separator'></i>"
}



// WEBPACK FOOTER //
// ./src/editor/modules/separator.js